import React from 'react';

import { SectionContainer, SectionHeader, SectionLabel, SectionRule } from './wallet-section.styles';

type WalletSectionProps = {
  title: string;
  children: React.ReactNode;
  id?: string;
};

export const WalletSection = ({ title, children, id }: WalletSectionProps): JSX.Element => (
  <SectionContainer id={id}>
    <SectionHeader>
      <SectionLabel size='xxsmall' weight='semi' casing='uppercase' tag='h2'>
        {title}
      </SectionLabel>
      <SectionRule aria-hidden />
    </SectionHeader>
    {children}
  </SectionContainer>
);
